import { can, canReadModule } from "../config/adminRbac";

function stripMeta(item) {
  const { rbacModule, rbacAction, superAdminOnly, roleId, ...rest } = item;
  const next = { ...rest };
  if (next.content?.length) {
    next.content = next.content.map(stripMeta);
  }
  return next;
}

function filterItem(item, permState) {
  if (item.superAdminOnly && !permState?.isSuperAdmin) {
    return null;
  }
  if (item.rbacModule) {
    const action = item.rbacAction;
    const ok = action ? can(permState, item.rbacModule, action) : canReadModule(permState, item.rbacModule);
    if (!ok) return null;
  }
  if (item.content?.length) {
    const kids = item.content
      .map((c) => filterItem(c, permState))
      .filter(Boolean);
    if (!kids.length) return null;
    return stripMeta({ ...item, content: kids });
  }
  return stripMeta(item);
}

/**
 * @param {Array} navItems - Nav tree with optional rbacModule / superAdminOnly
 * @param {object} permState - Redux permissions slice
 */
export function filterNavByRbac(navItems, permState) {
  if (!Array.isArray(navItems)) return [];
  return navItems.map((item) => filterItem(item, permState)).filter(Boolean);
}
